import axios from "axios";
import { Urls } from "../../urls";


// Article App repos
export const getArticleAppListRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_APPS_ARTICLE_LIST_API,
        params: params,
    });
};

export const getArticleAppFilterRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_APPS_ARTICLE_FILTER_API,
        params: params,
    });
};

export const getArticleAppDetailRepo = (id,data) => {
    return axios({
        method: "GET",
        url: Urls.GET_APPS_ARTICLE_DETAIL_API +id,
        params: data,
    });
};

export const putArticleAppDetailRepo = (id,data) => {
    return axios({
        method: "PUT",
        url: Urls.GET_APPS_ARTICLE_DETAIL_API + id,
        data: data,
    });
};

// Web Stories' repos
export const getWebStoryFilterRepo = (data) => {
    return axios({
        method : "GET",
        url: Urls.GET_WEB_STORY_FILTER_API,
        params: data,
    })
}

export const getWebStorylistRepo = (data) => {
    return axios({
        method : "GET",
        url: Urls.GET_WEB_STORY_LIST_API,
        params: data,
    })
}

export const getWebStoryAddEditRepo = (data) => {
    return axios({
        method : "GET",
        url: Urls.GET_WEB_STORY_ADD_EDIT_API,
        params: data,
    })
}

export const putWebStoryRepo = (id,data) => {
    return axios({
        method: "PUT",
        url: Urls.GET_WEB_STORY_ADD_EDIT_API,
        data: data,
    });
};

export const getEntityFilterRepo = (data) => {
    return axios ({
        method: "GET",
        url: Urls.GET_WEB_STORY_ENTITY_FILTER_API,
        params: data,
    })
}

export const postEntityFilterRepo = (data) => {
    return axios ({
        method: "POST",
        url: Urls.GET_WEB_STORY_ENTITY_FILTER_API,
        data,
        headers: {
            "Content-Type": "application/json",
          },
    })
}

export const deleteEntityFilterRepo = (data) => {
    return axios ({
        method: "DELETE",
        url: Urls.GET_WEB_STORY_ENTITY_FILTER_API,
        data,
    })
}

// Content Scheduler Repos
export const getSchedulerFilterRepo = (data) => {
    return axios ({
        method: "GET",
        url: Urls.GET_CMS_FILTER_API,
        params: data,
    })
}

export const getSchedulerListRepo = (data) => {
    return axios ({
        method: "GET",
        url: Urls.GET_CMS_PAGINATED_LIST_DATA,
        params: data,
    })
}

export const getSchedulerDraftsRepo = (data) => {
    return axios ({
        method: "GET",
        url: Urls.GET_CMS_VIEW_DRAFT_API,
        params: data,
    })
}

export const getSchedulerQueueRepo = (data) => {
    return axios ({
        method: "GET",
        url: Urls.GET_CMS_QUEUE_API,
        params: data,
    })
}

export const getScheduleDraftRepo = (data) => {
    return axios ({
        method: "GET",
        url: Urls.SET_DRAFT_SCHEDULE_API,
        params: data,
    })
}

export const putScheduleDraftRepo = (data) => {
    return axios ({
        method: "PUT",
        url: Urls.SET_DRAFT_SCHEDULE_API,
        params: {id:data?.id},
        data,
    })
}

export const getPublishedContentRepo = (params) => {
    return axios ({
        method: "GET",
        url: Urls.GET_PUBLISHED_CONTENT_API,
        params,
    })
}

export const getPublishedNowRepo = (params) => {
    return axios ({
        method: "GET",
        url: Urls.GET_PUBLISH_NOW_API,
        params,
    })
}